import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../../components/SectionWrapper/SectionWrapper';
import DteBulkDownloadForm from '../../../features/reports/dteBulkDownload/DteBulkDownloadForm';
import WorkspaceLayout from '../../../layout/WorkspaceLayout';

const DteBulkDownloadPage = () => (
  <WorkspaceLayout>
    <BreadcrumbTwo />
    <SectionWrapper>
      <DteBulkDownloadForm />
    </SectionWrapper>
  </WorkspaceLayout>
);

export default DteBulkDownloadPage;
